/**
 * @fileOverview Line Chart
 */
import generateCategoricalChart from './generateCategoricalChart';
import Line from '../cartesian/Line';
import XAxis from '../cartesian/XAxis';
import YAxis from '../cartesian/YAxis';
import { formatAxisMap } from '../util/CartesianUtils';

export default generateCategoricalChart({
  chartName: 'LineChart',
  GraphicalChild: Line,
  axisComponents: [{ axisType: 'xAxis', AxisComp: XAxis }, { axisType: 'yAxis', AxisComp: YAxis }],
  formatAxisMap: formatAxisMap
});


//////////////////
// WEBPACK FOOTER
// ./~/recharts/es6/chart/LineChart.js
// module id = 1516
// module chunks = 0